export const SUPPORTED_LANGS = ['en', 'fr', 'de', 'it', 'es', 'nl'] as const;

export type Locale = (typeof SUPPORTED_LANGS)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const isSupportedLocale = (value: string): value is Locale =>
  (SUPPORTED_LANGS as readonly string[]).includes(value);

export const toLanguageCode = (code: string): string => code.trim().toLowerCase().split(/[-_]/)[0] ?? '';

export const toLanguageCodes = (codes: readonly string[]): string[] => [
  ...new Set(codes.map(toLanguageCode).filter((code) => code !== '')),
];

export const resolveBrowserLocale = (
  languages: readonly string[] = typeof navigator !== 'undefined' ? navigator.languages : [],
): Locale => {
  for (const language of languages) {
    const base = toLanguageCode(language);
    if (isSupportedLocale(base)) return base;
  }
  return DEFAULT_LOCALE;
};
